import { render, staticRenderFns } from "./Painter.vue?vue&type=template&id=0124e9ab&scoped=true&"
import script from "./Painter.vue?vue&type=script&lang=ts&"
export * from "./Painter.vue?vue&type=script&lang=ts&"
import style0 from "./Painter.vue?vue&type=style&index=0&id=0124e9ab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0124e9ab",
  null
  
)

export default component.exports